<template>
    <div :class="{white:colour!=''}" class="footerBox">
        <div class="center clearfix footers">
            <!-- <dl class="fl alliance">
                <dt>关于位讯</dt>
                <dd><a href="/CLUB/index.html" target="_blank">关于我们</a></dd>
                <dd><a href="/POSTER/index.html" target="_blank">向导合作</a></dd>
                <dd><a href="/wechat/index.html" target="_blank">供应商加盟</a></dd>
            </dl> -->
            <dl class="fl alliance">
                <dt>相关链接</dt>
              <dd><a href="https://www.wiicent.com/org" target="_blank">旅协通信息管理平台</a></dd>
<!--              <dd><a href="https://www.wiicent.com/mall" target="_blank">趣旅淘购物管理系统</a></dd>-->
<!--                <dd><a href="https://www.wiicent.com/gms" target="_blank">位讯优导派团管理系统</a></dd>-->
            </dl>
            <dl class="fl contact">
                <dt>联系我们</dt>
<!--                <dd>咨询电话:17665015547</dd>-->
                <dd>邮箱：<a href="mailto:wayne@wiicent.com">wayne@wiicent.com</a></dd>
                <dd>地址：广州市越秀区西湖路12号第30层自编号46号</dd>
            </dl>
            <div class="fr hkmovie">
                <p>位讯科技公众号</p>
                <div>
                    <img :src="hkmovie" alt="">
                </div>
            </div>
        </div>

        <p class="Copyright">Copyright © 2019-2020 广州市位讯信息科技有限责任公司版权所有    备案号：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备16032631号</a></p>

        </div>
</template>
<script>
  import global_ from './../../store/global'
export default {
  name: 'footer',
  data () {
    return {
        hkmovie:global_.imgUrl+'hkmovie.jpg'
    }
  },
  props:['colour']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .footerBox{
        position: relative;
        display: block;
        width: 100%;
        min-width:1200px;
        overflow: hidden;
        background: #312d2a !important;

        &.white{
            background-color: #fff !important;
            .footers{
                color: #333;
                border-bottom: 1px solid #eee;
                a{
                    color:#333;
                    &:hover{
                        color: #333;
                    }
                }
            }
            .Copyright{
                background-color: #fff;
                color: #999;
            }
        }
        .footers{
            padding: 40px 0;
            color: #fff;
            .contact{
                width: 400px;
                margin-left: 62px;
            }
            .alliance{
                width: 200px;
                margin-left: 1px;
            }
            dl{
                margin-bottom: 0px;
                dt{
                    font-size: 18px;
                    line-height: 24px;
                    margin-bottom: 40px;
                    margin-top: 20px;
                    font-weight: normal;
                }
                dd{
                    font-size: 14px;
                    margin: 15px 0;
                    line-height: 24px;
                    &:last-of-type{
                        margin-bottom: 0px;
                    }
                    a{
                        color: #fff;
                        &:hover{
                            color:#fff;
                            text-decoration: underline;
                        }
                    }
                }

            }
            .hkmovie{
                text-align: center;
                margin-right: 20px;
                p{
                    font-style: 14px;
                    line-height: 24px;
                    margin-bottom: 10px;
                    margin-top: 20px;
                }
            }

        }
        .Copyright{
            background-color: #3c3936;
            width: 100%;
            min-width: 1200px;
            text-align: center;
            color: #c3c3c3;
            padding: 15px 0;
            font-size: 12px;
            line-height: 24px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue